import { clearDateFilterAction, selectDateFilterAction } from '../actions/publicActions';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { assertNever } from 'owa-assert';
import { showRangeDatePickerModal } from 'owa-range-datepicker-modal';
import {
    getAllDateRangeOptions,
    DateRangeOption,
    getTextLabelForOption,
    getDateRangeForOption,
} from 'owa-files-filter-date-filter';

const styles = require('./DateRangeFilterContextMenu.scss');

export type IsDateRangeOptionSelectedFuncType = (value: DateRangeOption) => boolean;

export function getDateRangeContextMenuItems(
    isDateRangeOptionSelectedFunc: IsDateRangeOptionSelectedFuncType
): IContextualMenuItem[] {
    const dateRangeOptions = getAllDateRangeOptions();

    return dateRangeOptions.map<IContextualMenuItem>(option => {
        return {
            key: option.toString(),
            name: getTextLabelForOption(option),
            canCheck: true,
            checked: isDateRangeOptionSelectedFunc(option),
            itemProps: {
                styles: { icon: styles.noIcon },
            },
            onClick: event =>
                onDateRangeContextMenuClicked(event, option, isDateRangeOptionSelectedFunc),
        };
    });
}

function onDateRangeContextMenuClicked(
    event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
    option: DateRangeOption,
    isDateRangeOptionSelectedFunc: IsDateRangeOptionSelectedFuncType
) {
    event.preventDefault();
    switch (option) {
        case DateRangeOption.LastWeek:
        case DateRangeOption.Month:
        case DateRangeOption.Week:
            if (isDateRangeOptionSelectedFunc(option)) {
                clearDateFilterAction();
            } else {
                selectDateFilterAction({
                    option: option,
                    dateRange: getDateRangeForOption(option),
                });
            }
            break;
        case DateRangeOption.CustomDateRange:
            const currentSelection = getSelectedDateRangeOption(isDateRangeOptionSelectedFunc);
            showRangeDatePickerModal(
                result =>
                    selectDateFilterAction({
                        option: option,
                        dateRange: result,
                    }),
                () => {} /* reject function */,
                {
                    defaultDateRange: currentSelection
                        ? getDateRangeForOption(currentSelection)
                        : null,
                }
            );
            break;
        default:
            assertNever(option);
    }
}

function getSelectedDateRangeOption(
    isDateRangeOptionSelected: IsDateRangeOptionSelectedFuncType
): DateRangeOption | null {
    const [selected] = getAllDateRangeOptions().filter(isDateRangeOptionSelected);
    return selected || null;
}
